import React from 'react';
import { useTranslation } from 'react-i18next';
import './MoonParties.css';

function MoonParties() {
  const { t } = useTranslation();

  return (
    <section className="moon-parties" id="parties">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('parties.title')}</h2>
          <p className="section-description">
            {t('parties.description')}
          </p>
        </div>

        <div className="parties-grid">
          <div className="party-card full-moon-card animate-fade-in-up">
            <div className="moon-icon full-moon">🌕</div>
            <div className="party-content">
              <h3>{t('parties.fullMoon')}</h3>
              <p>Experience the energy of the full moon with our special celestial celebrations featuring ethereal soundscapes and cosmic vibes.</p>
              <div className="party-features">
                <span className="feature-tag">Cosmic Beats</span>
                <span className="feature-tag">Sacred Sounds</span>
                <span className="feature-tag">Full Energy</span>
              </div>
            </div>
            <div className="party-glow full-moon-glow"></div>
          </div>

          <div className="party-card new-moon-card animate-fade-in-up">
            <div className="moon-icon new-moon">🌑</div>
            <div className="party-content">
              <h3>{t('parties.newMoon')}</h3>
              <p>Dive deep into introspective rhythms during our new moon gatherings, where minimal beats meet maximum consciousness.</p>
              <div className="party-features">
                <span className="feature-tag">Deep House</span>
                <span className="feature-tag">Meditation</span>
                <span className="feature-tag">New Beginnings</span>
              </div>
            </div>
            <div className="party-glow new-moon-glow"></div>
          </div>
        </div>

        <div className="moon-phases">
          <div className="phase-indicator">
            <span className="phase-moon">🌑</span>
            <span className="phase-moon">🌒</span>
            <span className="phase-moon">🌓</span>
            <span className="phase-moon">🌔</span>
            <span className="phase-moon">🌕</span>
            <span className="phase-moon">🌖</span>
            <span className="phase-moon">🌗</span>
            <span className="phase-moon">🌘</span>
          </div>
          <p className="phases-text">Follow the lunar cycle with Radio Tunco</p>
        </div>
      </div>
    </section>
  );
}

export default MoonParties;